module.exports = __webpack_public_path__ + "img/orcid.4e928fd4.svg";